export default __webpack_public_path__ + "static/media/11.c4b3b733.png";